import { render, staticRenderFns } from "./CheckoutSummary.vue?vue&type=template&id=c0474a5e&"
import script from "./CheckoutSummary.vue?vue&type=script&lang=js&"
export * from "./CheckoutSummary.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSummary.vue?vue&type=style&index=0&id=c0474a5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports